import type { HttpRequest } from '@zoryn/network'
import type { DataGrid, GridOptions } from '../types'

type GridRequestHost = Pick<DataGrid, 'options' | 'request'>

const gridRequestByOptions = new WeakMap<object, HttpRequest>()

function resolveParentRequest(parent: GridOptions['parent']): HttpRequest | null {
  if (!parent || typeof parent !== 'object') {
    return null
  }
  return gridRequestByOptions.get(parent) ?? null
}

function rememberGridRequest(options: GridOptions, request: HttpRequest) {
  gridRequestByOptions.set(options, request)
}

/** 挂载时解析 request：parent 继承 → inject 默认值 */
export function ensureGridRequest(
  $grid: GridRequestHost,
  injected?: HttpRequest | null
) {
  if ($grid.request) {
    rememberGridRequest($grid.options, $grid.request)
    return
  }
  const parentRequest = resolveParentRequest($grid.options.parent)
  if (parentRequest) {
    $grid.request = parentRequest
    rememberGridRequest($grid.options, parentRequest)
    return
  }
  if (injected) {
    $grid.request = injected
    rememberGridRequest($grid.options, injected)
  }
}

export function resolveGridRequest($grid: GridRequestHost): HttpRequest {
  if ($grid.request) {
    return $grid.request
  }
  const cached = gridRequestByOptions.get($grid.options)
  if (cached) {
    return cached
  }
  const parentRequest = resolveParentRequest($grid.options.parent)
  if (parentRequest) {
    return parentRequest
  }
  throw new Error(
    '[Grid] 未配置 HttpRequest：请在应用入口 provide(GRID_HTTP_INJECTION_KEY, http)'
  )
}
